<div  class="chart-container">
    <div class="chart-container__buttons">
        <div class="chart-container__buttons__left">
            <button *ngFor="let button of customButtons; let i = index" 
                class="btn btn-chart"
                (click)="customButtonClicked(i)"
                [ngClass]="{'active': activeButtonIndex === i }">
                    {{ button.text | transloco }}
            </button>
        </div>
        <div class="chart-container__buttons__right">
            <button *ngIf="showScatterToggle"
                class="btn btn-chart"
                [ngClass]="{'active': scatterMode }"
                (click)="toggleScatterMode()">
                    {{ (scatterMode ? 'chart.line-mode' : 'chart.scatter-mode') | transloco }}
            </button>
            <button *ngIf="hideButton"
                class="btn btn-chart"
                [ngClass]="{'active': seriesHidden }"
                (click)="hideAllSeries()">
                    {{ 'chart.hide-button' | transloco }}
            </button>
        </div>
    </div>
    <div class="chart-container__header">
        <div class="chart-container__chart-header__title">{{ chartConfig?.title?.text }}</div>
        <!-- <div class="chart-container__chart-header__buttons">
            <button *ngFor="let button of customButtons; let i = index" 
                class="btn btn-chart"
                (click)="customButtonClicked(i)"
                [ngClass]="{'active': activeButtonIndex === i }">
                    {{ button.text | transloco }}
            </button>
            <button *ngIf="hideButton"
                class="btn btn-chart"
                [ngClass]="{'active': seriesHidden }"
                (click)="hideAllSeries()">
                    {{ 'chart.hide-button' | transloco }}
            </button>
        </div> -->
    </div>
    <div class="chart-container__no-data" *ngIf="chartConfig && !hasData">
        {{ 'chart.no-data' | transloco }}
    </div>
</div>
<div *ngIf="chartConfig && hasData" [id]="chartContainerId" style="width: 100%; height: 600px;"></div>
<div *ngIf="chartConfig && hasData && grandTotal > 0 && !hideGrandTotal" class="chart-container__grand-total">
    Total: {{ grandTotal | number }}
</div>
